import type { ComponentType } from 'react';
import {
  Anchor, Award, Beer, Bell, Bike, Bone,
  Book, Bookmark, Box, Briefcase, Bug, Building,
  Cake, Calendar, Camera, Car, ChefHat, Clapperboard,
  Clipboard, Cloud, Coffee, Cog, Compass, CreditCard,
  Crown, Database, Diamond, Dna, Dumbbell, Feather,
  File, Film, Fish, Flag, Flame, Fuel,
  Gamepad, Gavel, Gem, Gift, Globe, GraduationCap,
  Hammer, Handshake, Headphones, HeartPulse, Hourglass, House,
  IceCream, Image, KeyRound, Landmark, Leaf, Lightbulb,
  Lock, Map as MapIcon, MessageSquare, Mic, Moon, Mountain,
  Music, Newspaper, Package, Palette, PawPrint, Phone,
  Pill, Pizza, Plane, Printer, Puzzle,
  Receipt, Rocket, Scale, Scissors, Send, Sheet,
  Shield, ShoppingBag, Smile, Snowflake, Sparkles, Speaker,
  Star, Sun, Swords, Target, Ticket, Timer,
  Train, TreePine, Trophy, Truck, Umbrella, Users,
  Utensils, Video, Wallet, Wine, Wrench, Zap,
} from 'lucide-react';
import type { IconProps } from '../components/Primitives';

/**
 * Набор иконок документа — те же 103 ключа с теми же подписями, что в
 * восстановленном исходнике. Ключ хранится в Doc.icon, поэтому
 * переименовывать его нельзя: старые документы потеряют иконку.
 */
export interface DocIcon {
  key: string;
  label: string;
  Component: ComponentType<IconProps>;
}

export const DOC_ICONS: DocIcon[] = [
  { key: "file", label: "Документ", Component: File },
  { key: "spreadsheet", label: "Таблица", Component: Sheet },
  { key: "database", label: "База", Component: Database },
  { key: "clipboard", label: "Реестр", Component: Clipboard },
  { key: "book", label: "Справочник", Component: Book },
  { key: "bookmarked", label: "Закладка", Component: Bookmark },
  { key: "package", label: "Инвентарь", Component: Package },
  { key: "box", label: "Коробка", Component: Box },
  { key: "building", label: "Организация", Component: Building },
  { key: "home", label: "Дом", Component: House },
  { key: "users", label: "Люди", Component: Users },
  { key: "car", label: "Транспорт", Component: Car },
  { key: "truck", label: "Грузовик", Component: Truck },
  { key: "bike", label: "Байк", Component: Bike },
  { key: "plane", label: "Самолёт", Component: Plane },
  { key: "train", label: "Поезд", Component: Train },
  { key: "shield", label: "Безопасность", Component: Shield },
  { key: "sword", label: "Оружие", Component: Swords },
  { key: "lock", label: "Замок", Component: Lock },
  { key: "key", label: "Ключи", Component: KeyRound },
  { key: "wallet", label: "Кошелёк", Component: Wallet },
  { key: "creditcard", label: "Карта", Component: CreditCard },
  { key: "receipt", label: "Чек", Component: Receipt },
  { key: "gem", label: "Драгоценность", Component: Gem },
  { key: "diamond", label: "Алмаз", Component: Diamond },
  { key: "heartpulse", label: "Медицина", Component: HeartPulse },
  { key: "pill", label: "Лекарство", Component: Pill },
  { key: "dna", label: "ДНК", Component: Dna },
  { key: "bone", label: "Кость", Component: Bone },
  { key: "fuel", label: "АЗС", Component: Fuel },
  { key: "chef", label: "Ресторан", Component: ChefHat },
  { key: "utensils", label: "Столовые приборы", Component: Utensils },
  { key: "pizza", label: "Пицца", Component: Pizza },
  { key: "coffee", label: "Кофе", Component: Coffee },
  { key: "beer", label: "Бар", Component: Beer },
  { key: "wine", label: "Вино", Component: Wine },
  { key: "cake", label: "Торт", Component: Cake },
  { key: "icecream", label: "Мороженое", Component: IceCream },
  { key: "fish", label: "Рыба", Component: Fish },
  { key: "news", label: "Газета", Component: Newspaper },
  { key: "landmark", label: "Госорган", Component: Landmark },
  { key: "gavel", label: "Суд", Component: Gavel },
  { key: "scale", label: "Юстиция", Component: Scale },
  { key: "map", label: "Карта", Component: MapIcon },
  { key: "compass", label: "Компас", Component: Compass },
  { key: "globe", label: "Глобус", Component: Globe },
  { key: "mountain", label: "Гора", Component: Mountain },
  { key: "tree", label: "Дерево", Component: TreePine },
  { key: "leaf", label: "Лист", Component: Leaf },
  { key: "trophy", label: "Награда", Component: Trophy },
  { key: "award", label: "Медаль", Component: Award },
  { key: "crown", label: "Корона", Component: Crown },
  { key: "paw", label: "Питомцы", Component: PawPrint },
  { key: "briefcase", label: "Работа", Component: Briefcase },
  { key: "graduationcap", label: "Учёба", Component: GraduationCap },
  { key: "hammer", label: "Строительство", Component: Hammer },
  { key: "wrench", label: "Гаечный ключ", Component: Wrench },
  { key: "cog", label: "Настройки", Component: Cog },
  { key: "calendar", label: "Расписание", Component: Calendar },
  { key: "timer", label: "Таймер", Component: Timer },
  { key: "hourglass", label: "Ожидание", Component: Hourglass },
  { key: "zap", label: "События", Component: Zap },
  { key: "flame", label: "Огонь", Component: Flame },
  { key: "bell", label: "Уведомления", Component: Bell },
  { key: "star", label: "Избранное", Component: Star },
  { key: "bookmark", label: "Закладка", Component: Bookmark },
  { key: "flag", label: "Флаг", Component: Flag },
  { key: "rocket", label: "Быстрый старт", Component: Rocket },
  { key: "target", label: "Цель", Component: Target },
  { key: "ticket", label: "Билет", Component: Ticket },
  { key: "gift", label: "Подарок", Component: Gift },
  { key: "lightbulb", label: "Идея", Component: Lightbulb },
  { key: "sparkles", label: "Магия", Component: Sparkles },
  { key: "redwood", label: "Секвойя", Component: TreePine },
  { key: "sun", label: "Солнце", Component: Sun },
  { key: "moon", label: "Луна", Component: Moon },
  { key: "cloud", label: "Облако", Component: Cloud },
  { key: "snow", label: "Снег", Component: Snowflake },
  { key: "umbrella", label: "Зонт", Component: Umbrella },
  { key: "handshake", label: "Соглашение", Component: Handshake },
  { key: "message", label: "Сообщение", Component: MessageSquare },
  { key: "send", label: "Отправить", Component: Send },
  { key: "phone", label: "Телефон", Component: Phone },
  { key: "mic", label: "Микрофон", Component: Mic },
  { key: "headphones", label: "Наушники", Component: Headphones },
  { key: "speaker", label: "Динамик", Component: Speaker },
  { key: "music", label: "Музыка", Component: Music },
  { key: "video", label: "Видео", Component: Video },
  { key: "film", label: "Фильм", Component: Film },
  { key: "clapper", label: "Клакер", Component: Clapperboard },
  { key: "camera", label: "Камера", Component: Camera },
  { key: "image", label: "Изображение", Component: Image },
  { key: "printer", label: "Принтер", Component: Printer },
  { key: "gamepad", label: "Игры", Component: Gamepad },
  { key: "puzzle", label: "Пазл", Component: Puzzle },
  { key: "dumbbell", label: "Спорт", Component: Dumbbell },
  { key: "feather", label: "Перо", Component: Feather },
  { key: "palette", label: "Палитра", Component: Palette },
  { key: "scissors", label: "Ножницы", Component: Scissors },
  { key: "shopping", label: "Магазин", Component: ShoppingBag },
  { key: "anchor", label: "Якорь", Component: Anchor },
  { key: "smile", label: "Улыбка", Component: Smile },
  { key: "bug", label: "Баг", Component: Bug },
];

const BY_KEY = new Map(DOC_ICONS.map((i) => [i.key, i.Component]));

/** Неизвестный или пустой ключ — обычный документ. */
export function docIcon(key?: string | null): ComponentType<IconProps> {
  return (key && BY_KEY.get(key)) || DOC_ICONS[0].Component;
}
